import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import {Observable} from 'rxjs';
import {AngularFireAuth} from "@angular/fire/compat/auth";
import {filter, map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class AdminGuard  {

  constructor(private afAuth: AngularFireAuth, private router: Router) {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.afAuth.user
      .pipe(
        filter(u => u != null),
        map(u => {
          if (u.email != 'jdepypere@gmail.com') {
            this.router.navigate(['/blocked']);
          }
          return u.email === 'jdepypere@gmail.com';
        })
      );
  }

}
